import { render } from "./EditReleaseModal.vue?vue&type=template&id=5d2655ed"
import script from "./EditReleaseModal.vue?vue&type=script&lang=js"
export * from "./EditReleaseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__